export default __webpack_public_path__ + "static/media/td.bc395308.svg";